"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.getActiveLoomRoot = getActiveLoomRoot;
exports.resolveWeavePath = resolveWeavePath;
exports.ensureDir = ensureDir;
const path = __importStar(require("path"));
const fs = __importStar(require("fs-extra"));
const os = __importStar(require("os"));
const yaml = __importStar(require("yaml"));
/**
 * Resolves the absolute path to the currently active Loom workspace root.
 *
 * @param workspaceRoot - Optional explicit workspace root (used by VS Code extension).
 * @returns The absolute path to the active loom root.
 * @throws {Error} If no Loom workspace can be located.
 */
function getActiveLoomRoot(workspaceRoot) {
    // 1. PRIORITY: Use the explicitly provided workspace root if it contains .loom/
    if (workspaceRoot) {
        const loomDir = path.join(workspaceRoot, '.loom');
        if (fs.existsSync(loomDir)) {
            return workspaceRoot;
        }
    }
    // 2. Walk up from cwd looking for .loom/ (mono‑loom mode)
    let currentDir = process.cwd();
    while (true) {
        const loomDir = path.join(currentDir, '.loom');
        if (fs.existsSync(loomDir)) {
            return currentDir;
        }
        const parentDir = path.dirname(currentDir);
        if (parentDir === currentDir)
            break;
        currentDir = parentDir;
    }
    // 3. Try global registry (multi‑loom mode)
    const registryPath = path.join(os.homedir(), '.loom', 'config.yaml');
    if (fs.existsSync(registryPath)) {
        const registryContent = fs.readFileSync(registryPath, 'utf8');
        const registry = yaml.parse(registryContent);
        if (registry?.active_loom) {
            const configDir = path.dirname(registryPath);
            const activePath = path.resolve(configDir, registry.active_loom);
            if (fs.existsSync(activePath)) {
                return activePath;
            }
        }
    }
    throw new Error('No Loom workspace found.\n\n' +
        'If you are in a project that uses Loom, ensure it has a .loom/ directory.\n' +
        'If you want to create a new Loom workspace, run:\n' +
        '  loom init\n' +
        'If you have multiple looms, ensure one is active:\n' +
        '  loom list\n' +
        '  loom switch <name>');
}
/**
 * Resolves the absolute path to a specific weave.
 *
 * @param weaveSlug - The weave identifier.
 * @param workspaceRoot - Optional workspace root (used by VS Code extension).
 * @returns The absolute path to the weave directory.
 */
function resolveWeavePath(weaveSlug, workspaceRoot) {
    const loomRoot = getActiveLoomRoot(workspaceRoot);
    return path.join(loomRoot, 'weaves', weaveSlug);
}
/**
 * Ensures a directory exists, creating it recursively if necessary.
 *
 * @param dirPath - The directory path to ensure.
 */
async function ensureDir(dirPath) {
    await fs.ensureDir(dirPath);
}
